// used by the events company page and the sidebar components

import { debounce } from 'debounce'
import store from '@state/store'

const EventsParentMixin = {
  methods: {
    filterBetweenDates: debounce(async function filterBetweenDates(
      fromDate,
      toDate
    ) {
      await store.dispatch('events/setFilterInterval', {
        companyId: this.companyId,
        fromDate,
        toDate,
      })
    },
    500),
  },
}

export default EventsParentMixin
